<div class="question-library-item" [class.checked]="isChecked()">
  <mat-checkbox
    color="primary"
    [checked]="isChecked()"
    (click)="$event.stopPropagation()"
    (keydown)="$event.stopPropagation()"
    (change)="checked.emit($event)"
  ></mat-checkbox>

  <div class="question-library-item__content">
    <div class="question-library-item__content__text">
      <div class="eiq-id-badge clear">
        <fa-icon [icon]="questionTypeConfig[question().type].icon"></fa-icon>
        <span class="fs__xs fw__600">{{ questionTypeConfig[question().type].text }}</span>
      </div>
      <h2 class="question-library-item__content__text-title">{{ question().title | toPlainText }}</h2>
    </div>

    @if (question().options && question().options.length > 0) {
      <div>
        <h2 class="fs__sm fw__600">Options ({{ question().options.length }})</h2>
        <ol class="question-library-item__content__options">
          @for (option of optionsFiltered$(); track option.id) {
            <li class="fs__sm fw__500">{{ option.text | toPlainText }}</li>
          }
        </ol>

        @if (expandedOptions$()) {
          <span class="question-library-item__content__expand fs__sm fw__500" (click)="expandedOptions$.set(false)"
            >Hide <fa-icon [icon]="faChevronUp"></fa-icon
          ></span>
        } @else if (question().options.length - optionsFiltered$().length > 0) {
          <span class="question-library-item__content__expand fs__sm fw__500" (click)="expandedOptions$.set(true)">
            ... and {{ question().options.length - optionsFiltered$().length }} more options
            <fa-icon [icon]="faChevronDown"></fa-icon>
          </span>
        }
      </div>
    }

    @if (question().cards && question().cards.length > 0) {
      <div>
        <h2 class="fs__sm fw__600">Cards ({{ question().cards.length }})</h2>
        <ol class="question-library-item__content__options">
          @for (cards of cardsFiltered$(); track cards.id) {
            <li class="fs__sm fw__500">{{ cards.text | toPlainText }}</li>
          }
        </ol>

        @if (expandedCards$()) {
          <span class="question-library-item__content__expand fs__sm fw__500" (click)="expandedCards$.set(false)"
            >Hide <fa-icon [icon]="faChevronUp"></fa-icon
          ></span>
        } @else if (question().cards.length - cardsFiltered$().length > 0) {
          <span class="question-library-item__content__expand fs__sm fw__500" (click)="expandedCards$.set(true)">
            ... and {{ question().cards.length - cardsFiltered$().length }} more cards
            <fa-icon [icon]="faChevronDown"></fa-icon>
          </span>
        }
      </div>
    }
  </div>

  <div class="question-library-item__subfix">
    <button mat-icon-button title="Export to" color="light" [matMenuTriggerFor]="menu">
      <fa-icon [icon]="faEllipsisVertical"></fa-icon>
    </button>

    <mat-menu #menu="matMenu">
      <button mat-menu-item (click)="deleteQuestion.emit(question().id)">
        <span>Delete</span>
      </button>
    </mat-menu>
  </div>
</div>
